const fundingObj = {
    depositSource: [],
    fundsSource: '',
    anotherSource: '',
    otherNationality: [],
    depositAmount: '',
};

export default {
    using: {
        selectAccountPurpose: [],
        regularFundsDetailsObj: fundingObj,
        sourceSame: '',
        firstDepositDetailsObj: fundingObj,
    },
}
